import { render, staticRenderFns } from "./advertencia.vue?vue&type=template&id=0450b29e&"
import script from "./advertencia.vue?vue&type=script&lang=js&"
export * from "./advertencia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports